export default {
  en: {
    'bundles.api-settings.title': 'API Settings',
    'bundles.api-settings.credentials.title': 'API Credentials',
    'bundles.api-settings.credentials.add': 'Add API Credentials',
    'bundles.api-settings.no-credentials.title': 'No Credentials Found',
    'bundles.api-settings.not-allowed.title': 'Not Applicable',
    'bundles.api-settings.no-credentials.description':
      'No API credentials have been added for this entity yet.',
    'bundles.api-settings.credentials-not-allowed.description':
      'API credentials can only be added to ecommerce entities.',
    'bundles.api-settings.credentials-list.error': 'Error loading API credentials',
    'bundles.api-settings.credentials-list.delete.error':
      'Error deleting API credentials. Please try again.',
    'bundles.api-settings.credentials-list.delete.confirm':
      'Are you sure you want to delete these API credentials?',
    'bundles.api-settings.credentials-list.authentication.fallback': 'Not set',
  },
};
